import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
/**
 * @desc 导入需要的store
 * @author wtniu
 */
import managementStore from './management'

export default new Vuex.Store({
  state: {
    userId: '',//存放状态
    muneData:[],//list界面缓存状态
    LoginData:[]
  },
  mutations: {
    // 更改state中状态的逻辑，同步操作
  },
  actions: {
 // 提交mutation，异步操作
  },
  modules: {
    managementStore
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js